import "./SwipeableModals.scss";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import ShopPhoto from "./../../../assets/shop-img.png";
import StarIcon from "@mui/icons-material/Star";
import { Rating } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { ViewProductsRangesPriceColumns } from "../../../SourceData";

const SwipeableModals = ({ open, onClose, onOpen, currentView, item }) => {
  console.log(item);
  const renderViewProductRangesView = () => (
    <div className="user-modal">
      <p className="user-modal-p">نطاقات الاسعار</p>
      <DataGrid
        columns={ViewProductsRangesPriceColumns}
        rows={item?.prices}
        sx={{ backgroundColor: "white", width: "100%" }}
        hideFooter
      />
    </div>
  );

  const renderViewProductfeaturesView = () => (
    <div className="user-modal">
      <p className="user-modal-p">صور السمة</p>
      <div className="features-imgs-container">
        {item?.variations_images?.map((img, index) => (
          <img src={img?.image_path} alt="" key={index} />
        ))}
      </div>
    </div>
  );

  const renderUserProductRateView = () => (
    <div className="user-modal">
      <p className="user-modal-p">عرض التقييم</p>

      <div className="user-rate">
        <div className="img-container">
          <img src={ShopPhoto} alt="" />
          <p className="name">{item?.user_id?.name}</p>
          <div className="mobile-container">
            <span className="mobile-title">رقم الموبايل</span>
            <p className="mobile-number">{item?.user_id?.phone}</p>
          </div>
        </div>
        <Rating
          name="text-feedback"
          value={item?.rating || 0}
          readOnly
          precision={0.5}
          emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="10px" />}
        />
        <p className="rate-text">{item?.comment || "لا يوجد تعليق"}</p>
      </div>
    </div>
  );

  const renderDefaultView = () => <div></div>;

  const views = {
    viewProductranges: renderViewProductRangesView,
    viewProductfeatures: renderViewProductfeaturesView,
    viewUserProductrate: renderUserProductRateView,
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: "1202" }}
      disableScrollLock
    >
      {(views[currentView] || renderDefaultView)()}
    </SwipeableDrawer>
  );
};

export default SwipeableModals;
